import { z } from 'zod';
import { createFileRoute } from '@tanstack/react-router';
import { OverviewTab } from '@/components/health-readiness/overview/overview-tab';
import { ResolveHint } from '@/components/health-readiness/resolve-hint';
import { hrRedirect, targetOfItem } from '@/components/health-readiness/navigation';

/**
 * Health & Readiness → Overview (T-0242 / E22-F01).
 *
 * Also where E20's links land: `?item=domain:<id>`, `criterion:<id>`,
 * `findings` (with its `severity` / `status` / `domain` filters),
 * `interviews`, `report`, `snapshots` and `criterion:first` redirect to
 * their tab before anything loads; a `domain-name:<name>` hint waits for
 * the composite read, which knows the domain's id.
 */
const SearchSchema = z.object({
  item: z.string().min(1).optional(),
  severity: z.string().optional(),
  status: z.string().optional(),
  domain: z.string().optional(),
});

export const Route = createFileRoute('/engagements/$engagementId/health-readiness/')({
  validateSearch: SearchSchema,
  beforeLoad: ({ params, search }) => {
    if (!search.item && !search.severity && !search.status && !search.domain) return;
    const target = targetOfItem(search.item, {
      severity: search.severity,
      status: search.status,
      domain: search.domain,
    });
    if (target.tab === 'overview' && target.hint) return;
    throw hrRedirect(params.engagementId, target);
  },
  component: OverviewRoute,
});

function OverviewRoute() {
  const { engagementId } = Route.useParams();
  const { item } = Route.useSearch();
  if (item) return <ResolveHint engagementId={engagementId} hint={item} />;
  return <OverviewTab engagementId={engagementId} />;
}
